import { render, staticRenderFns } from "./DropZoneDataTable.vue?vue&type=template&id=27d12018&scoped=true&"
import script from "./DropZoneDataTable.vue?vue&type=script&lang=js&"
export * from "./DropZoneDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DropZoneDataTable.vue?vue&type=style&index=0&id=27d12018&scoped=true&lang=css&"
import style1 from "../../assets/css/style-tables-dark.css?vue&type=style&index=1&id=27d12018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d12018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VDataTable,VSimpleTable})
